import React from 'react';
import SeoHead from '../components/SeoHead';
import BookingForm from '../components/BookingForm';

export default function BookingPage() {
  const steps = [
    {
      title: '1. Send en uforpligtende forespørgsel',
      desc: 'Udfyld formularen med dine kontaktoplysninger og hvad din virksomhed ønsker hjælp til.',
    },
    {
      title: '2. Kort online forventningsafstemning',
      desc: 'Vi tager en hurtig, uforpligtende dialog online om jeres målgruppe, contentbehov og ønsker.',
    },
    {
      title: '3. Fleksibel aftale tilpasset jer (0 binding)',
      desc: 'Da alle virksomheder har forskellige behov, sammensætter vi en individuel aftale – uden faste pakker eller binding. Udnyt gerne vores tilbud: betal 2 mdr., få 1 mdr. gratis!',
    },
  ];

  return (
    <>
      <SeoHead
        title="Få en uforpligtende aftale | SoMe Sparring, Redigering & Synlighed"
        description="Få en skræddersyet SoMe-aftale uden binding. Sparring på optagelser, content redigering, Meta postkalender og profilopsætning."
      />

      <section className="pt-40 pb-20 md:pt-48 lg:pt-52 md:pb-28 bg-[#FAF8F5] border-b border-[#E8E2D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            {/* Left Context */}
            <div className="lg:col-span-5 space-y-8">
              <div className="space-y-4">
                <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#EAE4DC] text-xs font-semibold uppercase tracking-widest text-[#4A4640]">
                  <span>Sparring · Redigering · Synlighed</span>
                </div>
                <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-[#161514] leading-tight">
                  Skræddersyet aftale til{' '}
                  <span className="text-[#876F50]">jeres forretning</span>
                </h1>
                <p className="text-base text-[#5C5852] leading-relaxed">
                  Vi tror ikke på stive standardpakker. Hvert firma og hver forretning har brug for noget forskelligt i forskelligt omfang. Derfor laves alle vores aftaler individuelt gennem dialog.
                </p>
              </div>

              {/* Special Offer Box */}
              <div className="p-6 rounded-3xl bg-[#161514] text-[#FAF8F5] space-y-3 shadow-md">
                <div className="flex items-center gap-2 text-[#C5A880] text-xs font-bold uppercase tracking-wider">
                  <i className="fa-light fa-sparkles" aria-hidden="true" />
                  <span>Særtilbud uden binding</span>
                </div>
                <h3 className="text-xl font-bold text-white">
                  Betal for 2 måneder – få 1 måned gratis
                </h3>
                <p className="text-xs sm:text-sm text-[#C4BEB5] leading-relaxed">
                  Start jeres nye SoMe-opsætning med en ekstra måned uden omkostninger. Altid med 0 binding og fuld fleksibilitet.
                </p>
              </div>

              {/* What happens next */}
              <div className="bg-white border border-[#E5DFD6] rounded-3xl p-6 sm:p-8 space-y-6 shadow-xs">
                <h2 className="text-lg font-bold text-[#161514]">
                  Sådan kommer vi i gang:
                </h2>
                <div className="space-y-4">
                  {steps.map((s, idx) => (
                    <div key={idx} className="space-y-1">
                      <p className="text-sm font-semibold text-[#161514]">{s.title}</p>
                      <p className="text-xs text-[#5C5852] leading-relaxed">{s.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Direct questions */}
              <div className="p-6 rounded-2xl bg-[#F4EFEA] border border-[#E5DFD6] text-xs text-[#5C5852] space-y-2">
                <p className="font-semibold text-[#161514]">Spørgsmål inden du udfylder?</p>
                <p>
                  Ring direkte på{' '}
                  <a href="tel:+4561489206" className="font-bold text-[#161514] underline no-break">
                    +45 61 48 92 06
                  </a>{' '}
                  eller send en mail til{' '}
                  <a href="mailto:info.myserviceforyou@gmail.com" className="font-bold text-[#161514] underline no-break">
                    info.myserviceforyou@gmail.com
                  </a>.
                </p>
              </div>
            </div>

            {/* Right Booking Form */}
            <div className="lg:col-span-7">
              <BookingForm formType="booking" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
